import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { CommonModule } from '@angular/common';
import { UntypedFormGroup, FormControl, UntypedFormBuilder, FormArray, Validators, FormGroupDirective, NgForm, AbstractControl } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ErrorStateMatcher } from '@angular/material/core';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';



@Component({
    selector: 'app-signup-view',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.css']
})
export class SignUpComponent implements OnInit {

    model: any = {};
    loading = false;
    returnUrl: string;
    emailid;
    formdata;
    @Input() signupForm: UntypedFormGroup;
    isCompleted: true;
    showErrorMessage: boolean;
    showNotMatchedMessage: boolean;
    showAllFieldsMessage: boolean;
    deviceInfo = null;
    showinvalidmessage = false;

    SignUpForm: UntypedFormGroup;

    @Output() signupdata: EventEmitter<any> = new EventEmitter<any>(); // value to send back to Application list table



    constructor(private route: ActivatedRoute,
                private router: Router,
                private formBuilder: UntypedFormBuilder,
                private deviceService: DeviceDetectorService,
                private authenticationService: AuthenticationService) { }

    ngOnInit() {
        this.loading = false;
        this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/home/tabs';

        this.initForm();
    }


    get f() { return this.SignUpForm.controls; }

    initForm() {


        this.SignUpForm = this.formBuilder.group({
            firstName: ['', [Validators.required]],
            lastName: ['', [Validators.required]],
          //  username: ['', [Validators.required]],

            username: [null, {
              validators: [Validators.required],
              updateOn: 'blur',
              asyncValidators: [this.validateEmailCheck.bind(this), this.validateUserNameTaken.bind(this) ]
            }],


            // tslint:disable-next-line:max-line-length
            password: ['', [Validators.required, Validators.minLength(6), Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@#$!%^*?&])[A-Za-z\d$@#$!%^?&].{6,}')]],
            // tslint:disable-next-line:max-line-length
            passwordconfirm: ['', [Validators.required, Validators.minLength(6), Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@#$!%^?&])[A-Za-z\d$@#$!%^?&].{6,}')]]

        }, {validator: this.checkPasswords});
      }






    goForward(stepper: MatStepper) {


      this.SignUpForm.get('firstName').markAsTouched();
      this.SignUpForm.get('firstName').updateValueAndValidity();

      this.SignUpForm.get('lastName').markAsTouched();
      this.SignUpForm.get('lastName').updateValueAndValidity();

      this.SignUpForm.get('username').markAsTouched();
      this.SignUpForm.get('username').updateValueAndValidity();

      this.SignUpForm.get('password').markAsTouched();
      this.SignUpForm.get('password').updateValueAndValidity();

      this.SignUpForm.get('passwordconfirm').markAsTouched();
      this.SignUpForm.get('passwordconfirm').updateValueAndValidity();




      const fdata = this.SignUpForm.value;

      if (fdata.firstName === '' ||
      fdata.lastName === '' ||
      fdata.email === '' ||
      fdata.password === '' ||
      fdata.passwordconfirm === '') {

            this.showAllFieldsMessage = true;

            return false;
        } else { this.showAllFieldsMessage = false; }


      if (!this.SignUpForm.valid) {
      return false;
    } else {
      return true;

    }


    }



checkPasswords(group: UntypedFormGroup) { // here we have the 'passwords' group
const pass = group.get('password').value;
const confirmPass = group.get('passwordconfirm').value;
return pass === confirmPass ? null : { notSame: true };
}


onSearchChange(searchValue: string): void {

  if (!validateEmail(searchValue)) {

    const control = this.SignUpForm.get('username');
    control.setValidators([Validators.email]);
    control.markAsTouched();
    control.updateValueAndValidity();

    this.showinvalidmessage = true;

      } else { this.showinvalidmessage = false; }
}



validateUserNameTaken(control: AbstractControl) {


  return this.authenticationService
  .searchByUsername(control.value)
  .pipe(
    map(data => {
      return (data) ? { emailTaken: true } : null;
    }),
    catchError(error => null)
  );

}



validateEmailCheck(email): Observable<any> {



  return validateEmail(email.value)
  .pipe(
    map(data => {
      return (data) ? null :  { emailNotValid: true };
    }),
    catchError(error => null)
  );

/*
  // tslint:disable-next-line:max-line-length
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
 // return re.test(String(email).toLowerCase());

 console.log('email', of(re.test(String(email.value).toLowerCase()) ? null : { emailNotValid: true }));
  return of(re.test(String(email.value).toLowerCase()) ? null : { emailNotValid: true });*/


}



signin() {

  localStorage.setItem('refreshClicked', 'true');
}


}



function validateEmail(email): Observable<any> {
  // tslint:disable-next-line:max-line-length
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return of(re.test(String(email).toLowerCase()));
}
